import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";

const Login = () => {
  const form = document.getElementById("login_app_form");

  if (form) {
    const spinner = form.querySelector("button[type=submit] svg");
    const spinnerText = form.querySelector("button[type=submit] span");

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      // show ui
      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Logging in...";

      // add data to form
      const data = new FormData(form);
      data.append("action", "login_app");
      //console.log([...data]);

      // perform action
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Login";
            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
            });
          } else {
            createToast({
              type: "error",
              message: 'You provided invalid credentials.',
              duration: 1000,
            });
          }
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          spinner.classList.add("hidden!");
          spinnerText.textContent = "Login";
          createToast({
            type: "error",
            message: 'Authentication failed.',
            duration: 1000,
          });
        });
    });
  }
};

export { Login };
